import React from 'react';

const PreviewBanner = () => {
  return (
    <div className="NotificationContainer NotificationContainer--secondary mt-0">
      {t('notices.previewing_draft')}
    </div>
  );
};

export default PreviewBanner;
